import React from 'react'
import Video from './Video'
import "./About.css"
function About() {
  return (
    <section className="about">
    <div className="aboutContent">
      <h2>About Us</h2>
      <p>The academy aims to become a lead virtual resource institute imparting Islamic knowledge for people of all
        ages around the world, thereby molding morally conscious and socially committed Ummah who have profound
        scholarship in Islamic disciplines and are well equipped for constantly changing socio - cultural contexts.
        The academy aims to become a lead virtual resource institute imparting Islamic knowledge for people of all
        ages around the world, thereby molding morally conscious and socially committed Ummah who have profound
        scholarship in Islamic disciplines and are well equipped for constantly changing socio - cultural contexts.
      </p>
      <button>Read More</button>
    </div>
<Video/>
  </section>  )
}

export default About